import { Page } from '@/core/architecture'

import { IntegrationsTemplate } from './template'
import { useViewModel } from './viewModel'

export const Integrations: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <IntegrationsTemplate
      state={state}
      onConnectTwitter={actions.connectTwitter}
      onDisConnectTwitter={actions.disConnectTwitter}
    />
  )
}
